import React from 'react';
import { CalendarX, X } from 'lucide-react';
import { Button } from './Button';
interface MissedWorkoutModalProps {
  date: string;
  onOpenWorkout: () => void;
  onReschedule: () => void;
  onCancelWorkout: () => void;
  onClose: () => void;
}
export function MissedWorkoutModal({
  date,
  onOpenWorkout,
  onReschedule,
  onCancelWorkout,
  onClose
}: MissedWorkoutModalProps) {
  return <div className="absolute inset-0 bg-slate-900/40 backdrop-blur-sm z-50 flex items-center justify-center p-4 animate-in fade-in duration-200" data-id="element-227">
      <div className="bg-white w-full max-w-sm rounded-[2.5rem] p-6 shadow-2xl animate-in zoom-in-95 duration-200 relative" data-id="element-228">
        <button onClick={onClose} className="absolute top-4 right-4 p-2 text-slate-400 hover:text-slate-600 hover:bg-slate-100 rounded-full transition-colors" data-id="element-229">
          <X size={20} data-id="element-230" />
        </button>

        <div className="w-12 h-12 bg-pink-50 text-pink-500 rounded-full flex items-center justify-center mb-5 mx-auto" data-id="element-231">
          <CalendarX size={24} data-id="element-232" />
        </div>

        <div className="text-center mb-6" data-id="element-233">
          <h2 className="text-xl font-extrabold text-slate-800 mb-2" data-id="element-234">
            Missed workout?
          </h2>
          <p className="text-slate-500 font-medium text-sm leading-relaxed" data-id="element-235">
            You still have an unfinished workout scheduled for{' '}
            <span className="font-bold text-slate-700" data-id="element-236">{date}</span>. Choose
            what you’d like to do.
          </p>
        </div>

        <div className="space-y-3" data-id="element-237">
          <Button variant="primary" fullWidth onClick={onOpenWorkout} data-id="element-238">
            Do workout now
          </Button>
          <Button variant="outline" fullWidth onClick={onReschedule} data-id="element-239">
            Reschedule for later
          </Button>
          <button onClick={onCancelWorkout} className="w-full py-3 text-sm font-bold text-slate-400 hover:text-slate-600 transition-colors" data-id="element-240">
            Skip this workout
          </button>
        </div>
      </div>
    </div>;
}